"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var whichOneRuntime_1 = require("./whichOneRuntime");
var environment_1 = require("./environment");
var constants_1 = require("./constants");
var _a = whichOneRuntime_1.default().split('.'), runtime = _a[0], framework = _a[1];
function getVirtualEnv() {
    var containerEnv = {};
    switch (framework) {
        case constants_1.FRAMEWORK.VUE:
            var config = weex.config;
            var configEnv = config.env;
            containerEnv.platform = configEnv.platform;
            if (constants_1.RUNTIME.WEEX === runtime) {
                containerEnv.appVersion = configEnv.appVersion;
                containerEnv.appName = configEnv.appName;
            }
            break;
        case constants_1.FRAMEWORK.RAX:
            if (constants_1.RUNTIME.WEEX === runtime) {
                containerEnv.platform = navigator.platform;
                containerEnv.appName = navigator.appName;
                containerEnv.appVersion = navigator.appVersion;
            }
            break;
        case constants_1.FRAMEWORK.UNKNOWN:
            if (constants_1.RUNTIME.WEB === runtime) {
                containerEnv.platform = constants_1.RUNTIME.WEB;
            }
            if (constants_1.RUNTIME.UNKNOWN === runtime) {
                containerEnv.platform = constants_1.RUNTIME.UNKNOWN;
            }
            break;
    }
    return containerEnv;
}
var virtualEnv = getVirtualEnv();
var env = environment_1.default(runtime, framework, virtualEnv);
exports.default = env;
